import {Component, Input, OnDestroy} from '@angular/core';

import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';

import {Router} from '@angular/router';

@Component({
    selector: 'itpx-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css'],
    animations: [
        trigger('flyInOut', [
            state('in', style({})),
            transition('void => *', [
                animate(
                    300,
                    keyframes([
                        style({ opacity: 1, transform: 'scale3d(1, 1, 1)', offset: 0 }),
                        style({ opacity: 1, transform: 'scale3d(1.05, 1.05, 1.05)', offset: 0.5 }),
                        style({ opacity: 1, transform: 'scale3d(1, 1, 1)', offset: 1 })
                    ])
                )
            ])
        ])
    ]
})
export class TileComponent implements OnDestroy {
    @Input() redirectPath: string;
    @Input() redirectQueryParams: any;
    @Input() color: string;
    @Input() title: string;
    @Input() icon: string;
    @Input() iconSvg: string;
    @Input() description: string;
    @Input() disabled: boolean;
    @Input() url: string;

    isLoading: boolean = false;

    constructor(private router: Router) {}

    onClick() {
        if (this.url) {
            console.log(this.url);
            window.location.href = this.url;
        }

        if (!this.disabled) this.isLoading = true;
    }

    ngOnDestroy() {
        this.isLoading = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tile/tile.component.ts